import { Effect } from "effect";
import * as Command from "foldkit/command";
import * as Navigation from "foldkit/navigation";

import type { Page, PageReturn } from "../shared";
import { Message } from "./message";
import type { Model } from "./model";

/** v1: `navigate(-1)`. */
export const GoBack = Command.define("GoBack", {
	messages: [Message.CompletedGoBack],
	execute: Navigation.back().pipe(Effect.as(Message.CompletedGoBack())),
});

export const page: Page<Model, Message> = {
	init: () => ({ model: { page: "NotFound" } }),
	changedRoute: (model) => ({ model }),
	update: (model, message) =>
		Message.match<PageReturn<Model, Message>>(message, {
			ClickedGoBack: () => ({ model, commands: [GoBack()] }),
			CompletedGoBack: () => ({ model }),
		}),
};
